interface ScoreBarProps {
  label: string;
  /** 0–100. */
  value: number;
}

/**
 * One row of the read-only Big Five display: label on the left, numeric value
 * on the right, a filled bar underneath. Uses the same primary colour as the
 * intro chrome so the visual weight feels familiar.
 */
export function ScoreBar({ label, value }: ScoreBarProps) {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div className="space-y-1.5">
      <div className="flex items-baseline justify-between">
        <span className="text-sm text-foreground/85">{label}</span>
        <span className="font-serif text-base tabular-nums text-foreground">{clamped}</span>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
        <div
          className="h-full bg-primary transition-all duration-500"
          style={{ width: `${clamped}%` }}
          aria-hidden
        />
      </div>
    </div>
  );
}
